var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-content',{staticStyle:{"padding":"0"}},[_c('ConcilMainPanel')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }